import Vue from 'vue'
import Router from 'vue-router'
import Model from './views/Model.vue'
import SimpleModel from './views/SimpleModel.vue'
import SimpleCopperModel from './views/SimpleCopperModel.vue'
import ModelGrid from './views/ModelGrid.vue'
import Redirect from './views/Redirect.vue'
import DealRoom from './views/DealRoom.vue'
import Detour from './views/Detour.vue'
import Decar from './views/Decar.vue'
import Revenue from './views/Revenue.vue'
import Dashboard from './views/Dashboard.vue'

Vue.use(Router)

export default new Router({
  base: process.env.BASE_URL,
  mode: 'history',
  routes: [
    {
      path: '/agentis/:id',
      name: 'agentis',
      component: SimpleModel
    },
    {
      path: '/agentis/copper/:id',
      name: 'agentis',
      component: SimpleCopperModel
    },
    {
      path: '/model/:id',
      name: 'model',
      component: Model
    },
    {
      path: '/simplemodel/:id',
      name: 'simplemodel',
      component: SimpleModel
    },
    {
      path: '/simplecoppermodel/:id',
      name: 'simplecoppermodel',
      component: SimpleCopperModel
    },
    {
      path: '/modelgrid/:id',
      name: 'modelgrid',
      component: ModelGrid
    },
    {
      path: '/detour',
      name: 'Detour',
      component: Detour
    },
    {
      path: '/decar',
      name: 'Decar',
      component: Decar
    },
    {
      path: '/',
      name: 'Vrify',
      component: Redirect
    },
    {
      path: '/revenue',
      name: 'Revenue',
      component: Revenue
    },
    {
      path: '/dealroom',
      name: 'Deal Room',
      component: DealRoom
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard
    }
  ]
})
